import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { constants } from 'src/app/shared/constants';
import { AuthService } from '../auth';
import { AccessTokenService } from '../services';
import { CommonDataService } from '../services/common-data.service';
import { ConfirmationService } from 'primeng/api';


@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  constructor(private injector: Injector,
    private _accessTokenService: AccessTokenService,
    private _router: Router,
    private _commonDataService: CommonDataService,
  private _confirmationService: ConfirmationService) {
  }
  inflightAuthRequest: any;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.get('IgnoreAuth') === 'true') {
      return next.handle(req.clone());
    }

    // This is refresh token call
    const commonParams = {};

    req = req.clone({
      setParams: {
        ...commonParams
      }
    });
    if (req.headers.get('Content-Type') === 'application/x-www-form-urlencoded') {
      return next.handle(req);
    }

    const authService = this.injector.get(AuthService);
    const accessTokenService = this.injector.get(AccessTokenService);
    if (!this.inflightAuthRequest) {
      this.inflightAuthRequest = authService.getToken();
    }

    return this.inflightAuthRequest.pipe(
      switchMap((newToken: string) => {
        // unset request inflight
        this.inflightAuthRequest = null;
        let authReq;
        if (req.headers.get('removeContentType') === 'true') {
          // use the newly returned token
          authReq = req.clone({
            setHeaders: {
              'authorization': 'Bearer ' + newToken
            }
          });
        } else {
          // use the newly returned token
          authReq = req.clone({
            setHeaders: {
              'authorization': 'Bearer ' + newToken,
              'Content-type': 'application/json'
            }
          });
        }
        return next.handle(authReq);
      }),
      catchError(err => {
        // checks if a url is to an admin api or not
        if (err.status === 401 || err.status === 512) {
          // user session timeout
          if (err.status === 401 && err.error.message === constants.SESSION_EXPIRED) {
            this._accessTokenService.destroyToken();
            this._commonDataService.userDetails = null;
            this._commonDataService.userDetailsObservable = null;
            this._router.navigate(['home']);
            return throwError(err);
          }

          return throwError(err);
          /* if (err.status === 512 && err.error.error === constants.INACTIVE_SITE) {
            const redirectTo = 'assets/notify-error.html?error=' + btoa(err.error.error);
            location.href = redirectTo;
            return throwError(err);
          }
          if (!this.inflightAuthRequest) {
            this.inflightAuthRequest = authService.renewToken();
            if (!this.inflightAuthRequest) {
              // remove existing tokens
              accessTokenService.destroyToken();
              // location.href = '/api/login/dist/index.html';
              this._router.navigate(['login']);
              return throwError(err);
            }
          } 

          return this.inflightAuthRequest.pipe(
            switchMap((newToken: string) => {
              // unset inflight request
              this.inflightAuthRequest = null;

              // clone the original request
              const authReqRepeat = req.clone({
                setHeaders: {
                  'authorization': 'Bearer ' + newToken,
                  'Content-type': 'application/json'
                }
              });

              // resend the request
              return next.handle(authReqRepeat);
            })
          );*/
        } else {
          this._commonDataService.isLoading = false;
          this._confirmationService.confirm({
            message: "Some error occurred while performing the operation. Please contact system administrator.",
            rejectVisible: false,
            icon: 'pi pi-times-circle',
            acceptLabel: "OK",
            header: 'Error',
          });
          return throwError(err);
        }
      })
    );
  }

}
